import React from "react";
import { Cell } from "react-table";

interface Props {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	cell: Cell<{ [key: string]: string }, any>;
	rowIndex: number;
	className?: string;
	backgroundColor: string;
	isLastCell: boolean;
	rowsLength: number;
}

const TableCell = ({
	cell,
	rowIndex,
	className = "",
	backgroundColor,
	isLastCell,
	rowsLength,
}: Props) => {
	const actions = cell.column.id === "actions";

	return (
		<td
			{...cell.getCellProps({
				style: {
					background: isLastCell ? "" : backgroundColor,
					zIndex: rowsLength - rowIndex + 10,
				},
			})}
			className={`legacyArrayView-td ${className} ${
				actions ? "legacyArrayView-action" : ""
			}`}>
			<div className="legacyArrayView-ccell">{cell.render("Cell")}</div>
		</td>
	);
};

export default React.memo(TableCell);
